/* eslint-disable no-underscore-dangle */
import Aegis from '@src/slide/infrastructure/module/dependent/report/platform/aegis';
import MeetingEventBus from '@src/page/toc/common/meeting-room-manager/components/eventBus';
import { PlayerAction } from '@src/page/toc/common/meeting-room-manager/message_const';
import { when } from 'mobx';
import i18n from '@i18next/i18n';
import { waitForSlideModelReady } from './waitForSlideModelReady';
import { ISlideBaseAppServices } from '@src/slide/application/entry/toc/base/slide-base-app-services.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';

export function loadSlideStore() {
    const appService = AppServiceProvider.getInstance().getAppServices() as ISlideBaseAppServices;

    MeetingEventBus.sendPlayerEvent2Room(PlayerAction.DataLoading, { loadingText: i18n.t('正在加载幻灯片数据') });
    Aegis.getInstance().aegis.time('waitForModelReady');
    when(
        () => appService.getUiDataService().presentation.children.length
            === appService.getUiDataService().presentation.slideCount,
        () => {
            Aegis.getInstance().aegis.timeEnd('waitForModelReady');
            waitForSlideModelReady.resolve();
            setTimeout(() => MeetingEventBus.sendPlayerEvent2Room(PlayerAction.CancelDataLoading), 1000);
        },
    );

    const result = {
        presentation: appService.getUiDataService().presentation,
    };


    return result;
}
